<template>
  <Modal v-model:is-open="company_contacts_modal_open" default-success-msg="Note Deleted">
    <template #form="{ close: closeModal }">
      <h3 class="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-dark-body-text">
        {{ $t("Send email to these contacts") }}:
        <span class="text-md text-common-grey"> ({{ groupOrCompanyContacts.count - calcRemainingContacts() }} {{ $t("selected") }})</span>
      </h3>

      <div v-for="contact in groupOrCompanyContacts?.results" :key="contact.id" class="mb-4 border-b">
        <div class="flex items-center text-light-body-text dark:text-dark-body-text">
          <input
            :checked="calcContactChecked(contact)"
            type="checkbox"
            class="ml-2 mr-2 mt-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration"
            @input="(e) => handleSelectContact(e, contact)">
          <Avatar :user="Record.from(contact)" />
          <div>
            <div :class="['font-normal ml-3 block truncate']">
              {{ contact.values.contact_first_name }} {{ contact.values.contact_last_name }}
            </div>
            <div class="ml-3 text-light-body-text">
              {{ contact.values.contact_email }}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 text-center">
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 ml-2 font-medium border rounded-md dark:text-dark-body-text focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
          @click="closeModal">
          {{ $t("Close") }}
        </button>
      </div>
    </template>
    <template #done="{ close: closeModal }">
      <div class="float-right mt-5 sm:mt-6">
        <button type="button" class="cancel-btn" @click="closeModal">{{ $t("Done") }}</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/shared/Modal.vue"
import Avatar from "@/components/shared/Avatar.vue"
import { Record } from "@/models/record"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Modal,
    Avatar
  },
  props: {
    calcRemainingContacts: { type: Function, required: false, default: null },
    calcContactChecked: { type: Function, required: false, default: null },
    handleSelectContact: { type: Function, required: false, default: null },
    groupOrCompanyContacts: { type: Object, required: false, default: null }
  },
  emits: ["cancel", "submitted", "done"],
  data() {
    return {
      Record,
      company_contacts_modal_open: false
    }
  },
  created() {
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_EMAIL_FORM, () => {
        this.company_contacts_modal_open = true
      })
      this.$emitter.on(ALL_EMITTERS.OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_PLAYBOOKS, () => {
        this.company_contacts_modal_open = true
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_EMAIL_FORM)
      this.$emitter.off(ALL_EMITTERS.OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_PLAYBOOKS)
    }
  }
}
</script>
